import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

import DatePickerInput from 'components/DatePickerInput';
import TimeInput from 'components/TimeInput';
import styles from './styles';
import { useTimeSettingsFormat } from 'common/useTimeSettingsFormat';
import { convertTimeObject, convertTo24HourFormat } from 'common/dateFormatConfig';

const useStyles = makeStyles(styles);

const TimeForm = ({ selectedTime, setSelectedTime, openCalendar, formValues, errors }) => {
  const { is12Format } = useTimeSettingsFormat()();
  const classes = useStyles();
  const labels = [
    ['Start Date:', 'Start Time:'],
    ['End Date:', 'End Time:'],
  ];

  const toInput = (time) =>
    is12Format ? time : { ...time, hour: convertTo24HourFormat(time.hour, time.amPm) };

  const handleTimeChange = (index) => (time) =>
    setSelectedTime((prev) =>
      prev.map((value, i) =>
        i === index ? { ...value, time: is12Format ? time : convertTimeObject(time, true) } : value
      )
    );

  const fields =
    formValues.holidayType === 'period' ? selectedTime : [{ date: selectedTime[0].date }];

  return (
    <Grid container>
      {fields.map(({ date, time }, i) => (
        <React.Fragment key={i}>
          <Grid item className={classnames(classes.rootContainer, classes.dateColumn)}>
            <label htmlFor={`date-${i}`} className={classes.label}>
              <Typography variant="body1" color="textSecondary">
                {labels[i][0]}
              </Typography>
              <div className={classes.dateContainer} onClick={openCalendar(i)}>
                <DatePickerInput
                  selectedDay={date}
                  setFieldValue={() => null}
                  field="startDate"
                  // disabled
                  picker
                  fullwidth
                />
              </div>
            </label>
          </Grid>
          {time && (
            <Grid item className={classes.rootContainer}>
              <label className={classes.label}>
                <Typography variant="body1" color="textSecondary">
                  {labels[i][1]}
                </Typography>
                <TimeInput
                  className={classes.timeField}
                  value={toInput(time)}
                  onChange={handleTimeChange(i)}
                  error={!!errors?.startHours}
                />
              </label>
            </Grid>
          )}
        </React.Fragment>
      ))}
      <Grid style={{ padding: '0px 4px 10px' }} xs={12}>
        {errors?.startHours ? (
          <div className={classes.error}>{errors.startHours?.message}</div>
        ) : null}
      </Grid>
    </Grid>
  );
};

export default TimeForm;
